<!-- Group Permissions -->
<div class="grid-x permission-container">
  <div class="cell">
    <h3 class="no-margin">{{groupTitle}}</h3>
  </div>
  <div class="cell medium-5">
    <label class="bold">{{availableTitle}}:</label>
    <label><span>Filter:</span><input type="text" [formControl]="searchControl" /></label>
    <select multiple [(ngModel)]="availableItems_selected" class="no-margin select-scroll-x" #available (blur)="clearSelection($event)">
      @for (q of filteredAvailableItems; track q) {
        <option [ngValue]="q">{{getDisplay(q)}}</option>
      }
    </select>
  </div>
  <div class="cell medium-2 vertical-center-buttons">
    <button class="button permission-button available" (click)="makeAvailable()" attr.aria-label="Make Selected '{{selectedTitle}}' Unavailable" [disabled]="selectedItems_selected.length==0">&laquo;</button>
    <button class="button permission-button selected" (click)="makeSelected()" attr.aria-label="Make Selected '{{availableTitle}}' Available">&raquo;</button>
  </div>
  <div class="cell medium-5">
    <label class="bold">{{selectedTitle}}:</label>
    <label><span>Filter:</span><input type="text" [formControl]="selectedSearchControl" /></label>
    <select multiple [(ngModel)]="selectedItems_selected" class="no-margin select-scroll-x" #selected (blur)="clearSelection($event)">
      @for (q of filteredSelectedItems; track q) {
        <option [ngValue]="q">{{getDisplay(q)}}</option>
      }
    </select>
  </div>
</div>